<template>
  <div>
    <PageAllow
      controller="FoodTemplateRelations"
      :action="savable ? 'batchSave' : 'viewByTemplate'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">TODO</v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import DishTemplateRelations from "@/api/dish_template_relations";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.dishManagement"),
          disabled: false,
          href: "/dishes",
        },
        {
          text: i18n.t("Nav.dishTemplates"),
          disabled: false,
          href: "/dish-templates",
        },
        {
          text: this.savable
            ? i18n.t("Nav.dishTemplatePriceSet")
            : i18n.t("Nav.dishTemplateDetail"),
          disabled: true,
        },
        {
          text:
            this.template && this.template.template_name
              ? this.template.template_name
              : i18n.t("Nav.dishTemplateDetail"),
          disabled: false,
          accent: true,
        },
      ];
    },

    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols", "accountInfo"]),
  },

  data: () => ({
    mode: "",
    foodSelecteds: [],
    options: {
      keyword: "",
      food_category_id: [],
      readonly: 1,
      status: [1], // 只获取生效的
      page: 1,
      sortBy: [],
      sortDesc: [],
    },
    paging: {},
    template: {},
    template_details: [],
  }),

  mounted() {
    this.mode = this.$route.params.mode;
    if (this.mode)
      this.$router.replace("/dish-templates/" + this.$route.params.id);
  },

  methods: {
    getTemplateDishesFromAPI() {
      DishTemplateRelations.fetchByTemplate(
        this.template.id,
        this.options
      ).then(
        function (response) {
          this.template = response.data.food_template_relations;
        }.bind(this)
      );
    },
  },

  watch: {
    mode: {
      handler() {
        // console.log("123");
        if (this.isView) {
          //   this.materialKeyword = "";
          //   this.categorySelecteds = [];
          //   this.changedDetails = [];
          //   this.priceTypeAll = -1;
          //   this.validAll = 1;
          //   this.followAll = false;
          this.options.readonly = 1;
        } else {
          this.options.readonly = 0;
        }
        // this.changedDetails = []; // 模式变化时清空已编辑数组
      },
    },
    foodSelecteds: {
      handler() {
        this.options.food_category_id = this.foodSelecteds.map(
          (category) => category.id
        );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getTemplateDishesFromAPI();
      },
    },
  },
};
</script>